export const menus = [
    {
        id: 'homePage',
        href: '/homePage',
        name: '首页',
        icon: 'el-icon-s-home',
        children: []
    }, {
        id: 'modelChecker',
        href: '/modelChecker',
        name: '项目监控',
        icon: 'el-icon-s-platform',
        children: [
            {
                id: "project",
                href: "/project",
                name: '项目工况',
            }, {
                id: "configuration",
                href: "/configuration",
                name: '组态监控',
            }
        ]
    }, {
        id: 'deviceMonitoring',
        href: '/deviceMonitoring',
        name: '设备监控',
        icon: 'el-icon-camera-solid',
        children: [
            {
                id: "deviceList",
                href: "/deviceList",
                name: '设备列表',
            }, {
                id: "historicalData",
                href: "/historicalData",
                name: '历史数据',
            }
        ]
    }, {
        id: 'alarms',
        href: '/alarms',
        name: '报警管理',
        icon: 'el-icon-message-solid',
        children: [
            {
                id: "alarmRules",
                href: "/alarmRules",
                name: '报警规则',
            }, {
                id: "alarmHistory",
                href: "/alarmHistory",
                name: '报警历史',
            }
        ]
    }, {
        id: 'energy',
        href: '/energy',
        name: '能耗分析',
        icon: 'el-icon-s-data',
        children: [
            {
                id: "overview",
                href: "/overview",
                name: '能耗概览',
            }, {
                id: "proEnergy",
                href: "/proEnergy",
                name: '项目能耗',
            }, {
                id: "energyHistory",
                href: "/energyHistory",
                name: '能耗明细',
            }
        ]
    }
]
